import React from 'react';
import { ReactJsonView } from 'react-scale/corp/components/ReactJsonView';
import { ISensorFusionUnifiedTaskLookupDto } from '@scale/sensor-fusion-shared';

import { openSelectedIfUrl } from '../helpers/url';

type SfuTaxonomyPanelProps = {
  task: ISensorFusionUnifiedTaskLookupDto;
};

const SfuTaskTaxonomyPanel = ({ task }: SfuTaxonomyPanelProps) => {
  return (
    <ReactJsonView
      src={task.taxonomy}
      name={false}
      theme="monokai"
      iconStyle="triangle"
      collapsed={1}
      onSelect={openSelectedIfUrl}
      collapseStringsAfterLength={120}
      groupArraysAfterLength={false}
      enableClipboard={true}
      displayObjectSize={false}
      displayDataTypes={false}
    />
  );
};

export default SfuTaskTaxonomyPanel;
